/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBreadcrumbFragment, BreadcrumbFragment, FullBreadcrumbFragment} from '@amblique/contentful/app/contentful/fragments/breadcrumb';

/**
 * Get a single Breadcrumb by ID (base - scalars only)
 */
export const getBaseBreadcrumbById = gql`
  ${BaseBreadcrumbFragment}

  query GetBaseBreadcrumbById($id: String!, $locale: String!, $preview: Boolean) {
    breadcrumb(id: $id, locale: $locale, preview: $preview) {
      ...BaseBreadcrumbFragment
    }
  }
`;

/**
 * Get a single Breadcrumb by ID (standard - 1 level deep)
 */
export const getBreadcrumbById = gql`
  ${BreadcrumbFragment}

  query GetBreadcrumbById($id: String!, $locale: String!, $preview: Boolean) {
    breadcrumb(id: $id, locale: $locale, preview: $preview) {
      ...BreadcrumbFragment
    }
  }
`;

/**
 * Get a single Breadcrumb by ID (full - 2 levels deep)
 */
export const getFullBreadcrumbById = gql`
  ${FullBreadcrumbFragment}

  query GetFullBreadcrumbById($id: String!, $locale: String!, $preview: Boolean) {
    breadcrumb(id: $id, locale: $locale, preview: $preview) {
      ...FullBreadcrumbFragment
    }
  }
`;

/**
 * Get all Breadcrumb entries with pagination (base - scalars only)
 */
export const getBaseBreadcrumbs = gql`
  ${BaseBreadcrumbFragment}

  query GetBaseBreadcrumbs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BreadcrumbOrder]
    $where: BreadcrumbFilter
    $preview: Boolean
  ) {
    breadcrumbCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBreadcrumbFragment
      }
    }
  }
`;

/**
 * Get all Breadcrumb entries with pagination (standard - 1 level deep)
 */
export const getBreadcrumbs = gql`
  ${BreadcrumbFragment}

  query GetBreadcrumbs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BreadcrumbOrder]
    $where: BreadcrumbFilter
    $preview: Boolean
  ) {
    breadcrumbCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BreadcrumbFragment
      }
    }
  }
`;

/**
 * Get all Breadcrumb entries with pagination (full - 2 levels deep)
 */
export const getFullBreadcrumbs = gql`
  ${FullBreadcrumbFragment}

  query GetFullBreadcrumbs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BreadcrumbOrder]
    $where: BreadcrumbFilter
    $preview: Boolean
  ) {
    breadcrumbCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBreadcrumbFragment
      }
    }
  }
`;
